module.exports = __webpack_public_path__ + "static/img/enviabout.4c2b6a4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/enviabout.png
// module id = i+tg
// module chunks = 1